import { PLATFORMS, type Platform } from '@rp/contracts'
import { Button } from '../../design'
import { SETTINGS_COPY } from './copy'

const CONNECT_LABELS: Record<Platform, string> = {
  facebook: SETTINGS_COPY.connectFacebook,
  instagram: SETTINGS_COPY.connectInstagram,
}

type ConnectChannelProps = {
  connecting: Platform | null
  disabled: boolean
  onConnect: (platform: Platform) => void
}

export const ConnectChannel = ({ connecting, disabled, onConnect }: ConnectChannelProps) => (
  <div className="channel-connect" role="group" aria-labelledby="channel-connect-heading">
    <h3 id="channel-connect-heading">{SETTINGS_COPY.connectTitle}</h3>
    <p className="settings-hint measure">{SETTINGS_COPY.connectHint}</p>
    <div className="channel-connect-actions">
      {PLATFORMS.map((platform) => (
        <Button
          key={platform}
          pending={connecting === platform}
          pendingLabel={SETTINGS_COPY.connecting}
          disabled={disabled || (connecting !== null && connecting !== platform)}
          onClick={() => onConnect(platform)}
        >
          {CONNECT_LABELS[platform]}
        </Button>
      ))}
    </div>
    <p className="settings-hint measure">{SETTINGS_COPY.instagramHint}</p>
  </div>
)
